import { fromJS } from 'immutable';
import moment from 'moment';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    data: {
        alwaysOn: [],
        alwaysOnKwh: 0,
        batteryData: [],
        boughtKwh: 0,
        classificationKwh: 0,
        classificationRate: 0,
        completeness1h: 0,
        completeness24h: 0,
        onOff: [],
        powerData: [],
        powerSingle: [],
        premiumData: [],
        recognitionCorrectness: 0,
        recognitionKwh: 0,
        recognitionRate: 0,
        recognitions: [],
        serverTs: 0,
        solarData: [],
        solarSoldKwh: 0,
        solarTotalKwh: 0,
        totalKwh: 0,
        usedKwh: 0
    },
    isLoading: false,
    isLive: true,
    from: 10 * 60 * 1000,
    to: 0,
    setTimestamp: moment().valueOf(),
    lastTs: 0
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // monitoring
        case CONSTANTS.ON_MONITORING_IS_LOADING:
            return state.set('isLoading', payload.isLoading);

        case CONSTANTS.ON_CLEAR_RAW_DATA:
            return state
                .setIn(['data', 'powerData'], fromJS([]))
                .setIn(['data', 'recognitions'], fromJS([]))
                .setIn(['data', 'onOff'], fromJS([]))
                .setIn(['data', 'solarData'], fromJS([]))
                .setIn(['data', 'batteryData'], fromJS([]))
                .set('lastTs', 0);

        case CONSTANTS.ON_RAW_DATA:
        {
            const lastTs = state.get('lastTs');
            const isLive = state.get('isLive');
            const from = moment().valueOf() - state.get('from');
            const data = payload.data && payload.data.toJS ? payload.data.toJS() : payload.data;

            // console.log(data);
            if(isLive && lastTs !== 0){
                // just new data are loaded
                const old = state.get('data');
                const oldData = old && old.toJS ? old.toJS() : old;
                const DATA = [];
                const SOLAR = [];
                const SINGLE = [];
                const PREMIUM = [];
                const BATTERY = [];
                //
                if(data.powerData !== null) {
                    for (const item of data.powerData)
                        if (item.id > from)
                            DATA.push(item);
                    for(const item of oldData.powerData)
                        if(item.id > from && (!data.powerData || data.powerData.length === 0 ||  data.powerData.length > 0 && item.id < data.powerData[data.powerData.length-1].id))
                            DATA.push(item);
                }
                if(data.solarData !== null) {
                    for (const item of data.solarData)
                        if (item.id > from)
                            SOLAR.push(item);
                    for(const item of oldData.solarData)
                        if(item.id > from && (!data.solarData || data.solarData.length === 0 ||  data.solarData.length > 0 && item.id < data.solarData[data.solarData.length-1].id))
                            SOLAR.push(item);
                }
                if(data.batteryData !== null) {
                    for (const item of data.batteryData)
                        if (item.id > from)
                            BATTERY.push(item);
                    for(const item of oldData.batteryData)
                        if(item.id > from && (!data.batteryData || data.batteryData.length === 0 ||  data.batteryData.length > 0 && item.id < data.batteryData[data.batteryData.length-1].id))
                            BATTERY.push(item);
                }
                if(data.powerSingle !== null) {
                    for (const item of data.powerSingle)
                        if (item.id > from)
                            SINGLE.push(item);
                    for(const item of oldData.powerSingle)
                        if(item.id > from && (!data.powerSingle || data.powerSingle.length === 0 ||  data.powerSingle.length > 0 && item.id < data.powerSingle[data.powerSingle.length-1].id))
                            SINGLE.push(item);
                }
                if(data.premiumData !== null) {
                    for (const item of data.premiumData)
                        if (item.id > from)
                            PREMIUM.push(item);
                    for(const item of oldData.premiumData)
                        if(item.id > from && (!data.premiumData || data.premiumData.length === 0 ||  data.premiumData.length > 0 && item.id < data.premiumData[data.premiumData.length-1].id))
                            PREMIUM.push(item);
                }
                // console.log('PREMIUM-> ', PREMIUM);
                state = state.set('data', fromJS({
                    ...data,
                    powerData: DATA,
                    solarData: SOLAR,
                    powerSingle: SINGLE,
                    premiumData: PREMIUM,
                    batteryData: BATTERY
                }));
            } else {
                // data reloaded
                state = state.set('data', payload.data);
            }
            if(isLive && data && data.powerData && data.powerData.length > 0) state = state.set('lastTs', data.powerData[0].id);
            return state;
        }

        case CONSTANTS.ON_MONITORING_IS_LIVE:
            return state.set('isLive', payload.isLive);

        case CONSTANTS.ON_MONITORING_SET_LAST_TS:
            return state.set('lastTs', payload.lastTs);

        case CONSTANTS.ON_MONITORING_SET_BOUNDS:
            // check if zoom has changed, if yes, empty the cache
            if(Math.abs((state.get('to') - state.get('from')) - (payload.to - payload.from)) > 1000)
            {
                state = state
                .setIn(['data', 'powerData'], fromJS([]))
                .setIn(['data', 'recognitions'], fromJS([]))
                .setIn(['data', 'onOff'], fromJS([]))
                .setIn(['data', 'solarData'], fromJS([]));

                state = state.setIn(['data', 'batteryData'], fromJS([]));
            }

            return state
                .set('setTimestamp', moment().valueOf())
                .set('lastTs', 0)
                .set('from', payload.from)
                .set('to', payload.to);

        default:
            return state;
    }
};

export default reducer;
